<template>
    <v-dialog
        transition="dialog-top-transition"
        max-width="600"
        v-model="showDialog"
        persistent
        @keydown.esc="closeDialog"
    >
        <template>
            <v-card>
                <v-toolbar color="deep-purple accent-4" class="text-white text-h6">
                    <span class="text-white"> Test Broadcast</span>
                </v-toolbar>
                <v-form v-model="formValid">
                    <v-card-text>
                        <div>
                            <v-text-field v-model="size" label="Jumlah Kontak"></v-text-field>
                        </div>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn @click="closeDialog">
                            Kembali
                        </v-btn>
                        <v-btn class="ml-2" style="color: white;"
                            color="deep-purple accent-3"
                            :loading="isLoading"
                            @click="tryBroadcast">
                            Salin dan Test
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </template>
    </v-dialog>
</template>
<script>
import axios from 'axios'

export default {
    props: ['showDialog', 'broadcastId'],

    components: {},

    data: function() {
        return {
            isLoading: false,
        }
    },

    methods: {
        tryBroadcast: async function() {
            this.isLoading = true 

            try {
                const body = {
                    size: this.size != "" ? parseInt(this.size) : 5
                }

                const { data } = await axios.put(process.env.VUE_APP_API_URL + `/broadcast/${this.broadcastId}/test-some-contacts`, body);

                this.closeDialog()

                this.$router.push({
                    name: 'broadcast',
                    params: { id: encodeURIComponent(data._id) }, 
                    query: { tabs: 'detail' }
                });
            } catch (error) {
                this.broadcastError = this.$helpers.createError(error);
                console.log("test-template", error);
            }


            this.isLoading = false 
        },
        closeDialog: function() {
            this.$emit('close-dialog', 'test2')
        },
    },
}

</script>
